import axios from '../modules/axios';

let tvas = (function () {
  let tvas = [];

  return {
    get: async () => {
      if (tvas.length === 0) {
        try {
          tvas = (await axios.get('tva_taux?tva_taux_deleted=0')).data;
        } catch {
          console.error('Impossible de récupérer les informations de TVA');
        }
      }

      return tvas;
    },
  };
})();

export default tvas;
